import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function LineReveal({ lines, className = "", delay = 0, testid }) {
  return (
    <span className={className} data-testid={testid}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.05, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeUp({ children, delay = 0, y = 30, className = "", testid }) {
  return (
    <motion.div
      className={className}
      data-testid={testid}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p
      className={`font-mono text-[11px] uppercase tracking-[0.3em] text-[#00F0FF] ${className}`}
    >
      {children}
    </p>
  );
}
